import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, ListItemText, IconButton, Collapse, Typography } from "@material-ui/core";
import { Remove as RemoveIcon, ExpandMore, ExpandLess } from "@material-ui/icons";

const labels = [
  { class: "forms.map.transects.stable", color: "#43a047" },
  { class: "forms.map.transects.accreted", color: "#1976d2" },
  { class: "forms.map.transects.eroded", color: "#ffa000" },
  { class: "forms.map.transects.criticallyEroded", color: "#d32f2f" },
];

const shoreSBiasLabels = [
  { class: "forms.map.transects.biasPositive", color: "#1976d2" },
  { class: "forms.map.transects.biasNegative", color: "#d32f2f" },
  { class: "forms.map.transects.biasNoData", color: "purple" },
];

const useStyles = makeStyles((theme) => ({
  icon: {
    margin: 0,
    fontSize: "1.75rem",
  },
  header: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none",
  },
}));

/**
 * @function TransectShapeList
 * @description Collapsible color legend for the transects layer. The default
 * legend shows the erosion classes; `variant="shoreSBias"` swaps it for the
 * Shore-S bias-sign colors (positive/negative/no data).
 */
const TransectShapeList = ({ variant }) => {
  const [t] = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const entries = variant === "shoreSBias" ? shoreSBiasLabels : labels;

  return (
    <>
      <div className={classes.header} onClick={() => setOpen((prev) => !prev)}>
        <Typography variant="caption" color="textSecondary" style={{ flex: 1 }}>
          {t("forms.map.transects.legend")}
        </Typography>
        <IconButton size="small">
          {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </IconButton>
      </div>
      <Collapse in={open}>
        {entries.map((label, index) => (
          <Grid key={index} container direction="row">
            <RemoveIcon style={{ color: label.color }} className={classes.icon} />
            <ListItemText secondary={t(label.class)} />
          </Grid>
        ))}
      </Collapse>
    </>
  );
};

export default TransectShapeList;
